export default __webpack_public_path__ + "static/media/slider7.f3ad07c7.jpeg";